import script from "./PCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./PCategories.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__